import { NextHead } from "../../src/landingPage/layouts/LayoutComponents/NextHead";
import { meta } from "../../src/landingPage/datasets/meta";
import { LeadTargeting } from "../../src/landingPage/views/Usecases/LeadTargeting/LeadTargeting";

const LeadTargetingPage = () => {
  return (
    <>
      <NextHead
        currentPath="/use-cases/lead-targeting"
        title={meta.usecases.leadtargeting.title}
        description={meta.usecases.leadtargeting.description}
      />
      <LeadTargeting />
    </>
  );
};

export const getStaticProps = () => {
  return {
    props: {
      wrapper: "MarketingWrapper",
    },
  };
};

export default LeadTargetingPage;
